/**
 * CR模块路由配置
 */

import { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'

const crRoutes: RouteRecordRaw[] = [
  {
    path: 'classroom',
    name: 'Classroom',
    redirect: '/classroom/history',
    meta: {
      titleKey: 'menu.classroom',
      title: '智慧教室',
      icon: 'BankOutlined',
      orderNo: 50,
      // 拥有任一智慧教室相关权限即可看到「智慧教室」一级菜单
      permissions: [
        Permission.CLASSROOM_USE,
        Permission.CLASSROOM_VIEW,
        Permission.CLASSROOM_MANAGE,
        Permission.CLASSROOM_VERSION_MANAGE
      ]
    },
    children: [
      {
        path: 'history',
        name: 'ClassroomHistory',
        component: () => import('@/modules/cr/views/cr-history/index.vue'),
        meta: {
          titleKey: 'menu.courseHistory',
          title: '课程记录',
          icon: 'HistoryOutlined',
          keepAlive: true,
          permissions: [Permission.CLASSROOM_VIEW]
        }
      },
      {
        path: 'version',
        name: 'ClassroomVersion',
        component: () => import('@/modules/cr/views/cr-version/index.vue'),
        meta: {
          titleKey: 'menu.versionConfig',
          title: '版本配置',
          icon: 'CloudDownloadOutlined',
          keepAlive: true,
          permissions: [Permission.CLASSROOM_VERSION_MANAGE]
        }
      }
    ]
  }
]

export default crRoutes
